import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const getThresholdList = async () => {
  const token = localStorage.getItem('token');
  try {
    console.log('token : ', token)
    const response = await axios.get(`${API_BASE_URL}/threshold`, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });
     console.log('✅ 알림 기준 시간 목록:', response.data);
    return response.data;
  } catch (error) {
    console.error('알림 기준 시간 조회 실패:', error);
    return { success: false, relation: [] };
  }
};

export const updateThreshold = async (id, minute_threshold) => {
   const token = localStorage.getItem('token');
  try {
    console.log('📤 요청 보냄:', { id, minute_threshold, token });
   const response = await axios.post(
      `${API_BASE_URL}/threshold`,
      {
        id,
        minute_threshold: Number(minute_threshold), // ✅ 숫자 변환
      },
      {
        headers: {
          Authorization: `Bearer ${token}`, // ✅ 토큰 추가
          "Content-Type": "application/json",
        },
      }
    );
    console.log('📥 응답 받음:', response.data);
    return response.data;
  } catch (error) {
    console.error('❌ 알림 기준 시간 수정 실패:', error.response || error.message || error);
    return { success: false };
  }
};
